import React from 'react';
import { WheelOfFortuneComponent } from '../../../../components/wheel-of-fortune/wheel-of-fortune.component';
import { OfferBase } from "./offer-base";

export class WheelOfFortuneOffer extends OfferBase {
    id = "wheelOfFortune";
    analyticsCategory = "CRM";

    shouldBeVisible(): boolean {
        return this.services.playerOfferings.hasWheelOfFortunePromotion && super.shouldBeVisible();
    }

    shoulUseLinkToOfferAnimation(): boolean {
        return false;
    }
    
    render() {
        return <WheelOfFortuneComponent/>
    }
}
